import { render, staticRenderFns } from "./VueExcelXlsx.vue?vue&type=template&id=79c67b7a"
import script from "./VueExcelXlsx.vue?vue&type=script&lang=js"
export * from "./VueExcelXlsx.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports